export const newPolicyTemplate = {
  id: null,
  amount: "",
  service_ids: [],
  user_ids: [],
  vehicle_ids: []
}
